import { useQuery } from "@tanstack/react-query";

import { api } from "utils/axios";
import useUrlParams from "utils/urlParms";

const GET_SKILL_ASSESMENT_QUERY = "get-skill-assesment";

const getSkillAssesment = async (params) => {
  try {
    const response = await api.get(`/skillAssessment`, { params });
    return response.data;
  } catch (e) {
    console.error(e, "Error fetching Skill assessment");
  }
};

const useGetSkillAssesment = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_SKILL_ASSESMENT_QUERY, params],

    queryFn: () => getSkillAssesment(params),
  });
};

export { useGetSkillAssesment, GET_SKILL_ASSESMENT_QUERY };
